import * as actions from '../actions/on-flit-operators-collection';
import * as models from '../../domain/models';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  items: Array<models.Operator>;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  items: [],
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return { ...state, isLoading: true };
    }

    case actions.LOAD_SUCCESS: {
      return {
        isLoaded: true,
        isLoading: false,
        items: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItems = (state: State) => state.items;
